export const REQUEST_TRANSLATIONS = 'REQUEST_TRANSLATIONS';
export const REQUEST_TRANSLATIONS_FAILED = 'REQUEST_TRANSLATIONS_FAILED';
export const RECEIVE_TRANSLATIONS = 'RECEIVE_TRANSLATIONS';
